import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useContext, useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from 'assets/img/team/3.jpg';
import imgAdmin from 'assets/img/team/admin.jpg';
import imgOperator from 'assets/img/team/operator.jpg';
import Avatar from 'components/common/Avatar';
import paths from 'routes/paths';
import { useAppContext } from 'providers/AppProvider';
import {listForeigner, listGender, listPosition} from "../../../lib/api/player";
import {list} from "../../../lib/api/federation";


const ProfileDropdown = () => {

    const {userApp} = useAppContext();
    const [imageAvatar, setImageAvatar] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        if (userApp?.role_type_id === "admin") setImageAvatar(imgAdmin);
        else if (userApp?.role_type_id === "operator") setImageAvatar(imgOperator);
        else {
            const imagePath = userApp?.role_type_id === "supervisor"
                ? userApp?.supervisor_image_path
                : userApp?.role_type_id === "judge"
                    ? userApp?.judge_image_path
                    : userApp?.club_image_path;

            setImageAvatar(imagePath
                ? `${process.env.REACT_APP_BASE_API_URL}/uploads/${imagePath}`
                : null);
        }
    }, [userApp]);

    const handleLogout = () => {
        localStorage.clear();
        navigate('/authentication/simple/login');
    };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
          <Avatar src={imageAvatar} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item className="text-warning" href="#!">
            <FontAwesomeIcon icon="user" className="me-1" />
            <span> {userApp?.name}</span>
          </Dropdown.Item>
            {userApp?.role_type_id === "clubs" ? (
                <>
                    <Dropdown.Divider />
                    <Dropdown.Item as={Link} to={`/contact-clubs/${userApp?.club_guid}`}>
                        Kontakti
                    </Dropdown.Item>
                </>
            ) : null}
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to={`/authentication/simple/reset-password`}> Promjena šifre </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={handleLogout}>
            Logout
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
